module.exports = __webpack_public_path__ + "static/media/04.56e6a2a8.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/style/img/monuments/brownandgray/04.jpg
// module id = 373
// module chunks = 0